import React from "react";
import PageHeader from "../components/PageHeader";

export default function BareActs() {
  const breadcrumbs = [
    { label: "Home", link: "/" },
        { label: "Bare Acts", active: true },
  ];

  const documents = [
    { title: "Juvenile Justice (Care and Protection of Children) Model Amendment Rules, 2022", size: "849.98 KB", date: "14-09-22", link: "/assests/img/BareActsFiles/juvenile-justice-care-and-protection-of-children-model-amendment-rules-en_01.pdf" },
    { title: "Commissions for Protection of Child Rights Act, 2005", size: "1.45 MB", date: "29-06-22", link: "/assests/img/BareActsFiles/commissions-for-protection-of-child-rights-act-2005_02.pdf" },
    { title: "Commissions for Protection of Child Rights (Amendment) Act 2006", size: "242.07 KB", date: "29-06-22", link: "/assests/img/BareActsFiles/commissions-for-protection-of-child-rights-amendment-act-2006_03.pdf" },
    { title: "Commission For Protection of Child Rights Rules, 2006", size: "729.49 KB", date: "29-06-22", link: "/assests/img/BareActsFiles/commission-for-protection-of-child-rights-rules-2006_04.pdf" },
    { title: "The Juvenile Justice (Care and Protection of Children) Model Amendment Rules, 2022", size: "2.50 MB", date: "29-06-22", link: "/assests/img/BareActsFiles/the-juvenile-justice-care-and-protection-of-children-model-amendment-rules-2022-englisy_05.pdf" },
    { title: "Juvenile Justice (Care and Protection of Children) Rules, 2007", size: "477.19 KB", date: "29-06-22", link: "/assests/img/BareActsFiles/juvenile-justice-care-and-protection-of-chidlren-rules-2007_06.pdf" },
    { title: "Juvenule Justice (Care and Protection of Children) Amendment Act, 2006", size: "2.51 MB", date: "29-06-22", link: "/assests/img/BareActsFiles/juvenule-justice-care-and-protection-of-children-amendment-act-2006_07.pdf" },
    { title: "Juvenile Justice (Care and Protection of Children) Amendment Act, 2011", size: "655.75 KB", date: "29-06-22", link: "/assests/img/BareActsFiles/juvenile-justice-care-and-protection-of-children-amendment-act-2011_08.pdf" },
    { title: "Juvenile Justice (Care and Protection of Children) Act, 2000", size: "1.50 MB", date: "29-06-22", link: "/assests/img/BareActsFiles/juvenile-justice-care-and-protection-of-children-act-2000_09.pdf" },
    { title: "The Juvenile Justice (Care And Protection Of Children) ACT, 2015", size: "502.16 KB", date: "29-06-22", link: "/assests/img/BareActsFiles/the-juvenile-justice-care-and-protection-of-children-act-2015_10.pdf" },
    { title: "The Juvenile Justice (Care and Protection of Children) Act 2015, Rules, 2016", size: "2.21 MB", date: "29-06-22", link: "/assests/img/BareActsFiles/the-juvenile-justice-care-and-protection-of-children-act-2015rules-2016-hindi-english_11.pdf" },
    { title: "Right of Children to Free and Compulsory Education Act 2009", size: "1.48 MB", date: "29-06-22", link: "/assests/img/BareActsFiles/right-of-children-to-free-and-compulsory-education-act-2009_12.pdf" },
    { title: "Right of Children to Free and Compulsory Education Rules, 2010", size: "4.49 MB", date: "29-06-22", link: "/assests/img/BareActsFiles/right-of-children-to-free-and-compulsory-education-rules-2010-english-and-hindi_13.pdf" },
    { title: "The Protection of Children from Sexual Offences Rules, 2020", size: "1.60 MB", date: "29-06-22", link: "/assests/img/BareActsFiles/pocso-rules-merged_14.pdf" },
    { title: "Protection of Children From Sexual Offences Act, 2012", size: "2.53 MB", date: "29-06-22", link: "/assests/img/BareActsFiles/protection-of-children-from-sexual-offences-act-2012-english-hindi_15.pdf" },
    { title: "Protection of Children From Sexual Offences Rules, 2012", size: "3.50 MB", date: "29-06-22", link: "/assests/img/BareActsFiles/protection-of-children-from-sexual-offences-rules-2012-hindi-english_16.pdf" }
  ];

  return (
    <>
      <PageHeader
        title="Bare Acts related to Children (Govt. of India)"
        breadcrumbs={breadcrumbs}
      />

      <section className="py-5 bg-light">
        <div className="container">
          <h2 className="text-center text-primary fw-bold mb-4">
            Bare Acts related to Children
          </h2>

          <div className="row g-4">
            {documents.map((doc, index) => (
              <div key={index} className="col-lg-4 col-md-6">
                <div className="h-100 bg-white p-4 rounded-4 shadow-sm border-start border-4 border-primary">
                  <h6 className="fw-bold text-primary mb-3">
                    {doc.title}
                  </h6>

                  <div className="d-flex justify-content-between mb-3 text-muted small">
                    {/* <span>📅 {doc.date}</span> */}
                    <span>📄 {doc.size}</span>
                  </div>

                  <a
                    href={doc.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-sm btn-primary rounded-pill w-100"
                  >
                    View / Download
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
